import createHasSubmitSucceeded from './selectors/hasSubmitSucceeded';
import plain from './structure/plain';
export default createHasSubmitSucceeded(plain);


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/redux-form/es/hasSubmitSucceeded.js
// module id = /xlX
// module chunks = 1